import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PrimaService
{
  constructor(
    private http:HttpClient
  )
  {
  }

  buscarPoliza(token:string, matricula:string, poliza:string, claimDate:string): Promise<any> {
    const url = environment.callCenterWSBase + "/Prima/";
    //const url = "https://localhost:32768" + "/Prima/";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
        'Accept': 'text/html application/json',
      })
      .set('Authorization', 'Bearer ' + token),

      params: new HttpParams({})
    };

    const query = {
      matricula: matricula,
      poliza: poliza,
      claimDate: claimDate
    };

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,query,httpOptions)
        .subscribe
        ({
          next:(response:any)=>{
            resolve(response);
          },
          error:(err)=>{reject(err)}
        });
    });
  }
}

class PrimaPoliza {

  public policyNumber:String;
  public startAt:Date;
  public endAt:Date;
  public vehicleDetails:VehicleDetails;
  public policyHolder:PolicyHolder;
  public windshieldCoverage:String;

  constructor(public pPolicyNumber:String, public pStartAt:Date, public pEndAt:Date, public pVehicleDetails: VehicleDetails, public pPolicyHolder: PolicyHolder , public pWindshieldCoverage:String) {

    this.policyNumber = pPolicyNumber;
    this.startAt = pStartAt;
    this.endAt = pEndAt;
    this.policyHolder = pPolicyHolder;
    this.windshieldCoverage = pWindshieldCoverage;
    this.vehicleDetails = pVehicleDetails;
    this.policyHolder = pPolicyHolder;
  }
}

class VehicleDetails {
  public maker:String;
  public model:String;
  public plateNumber:String;

  constructor(public pMaker:String, public pModel:String, public pPlateNumber:String) {
    this.maker = pMaker;
    this.model = pModel;
    this.plateNumber = pPlateNumber;
  }
}

class PolicyHolder {
  public fullName:String;
  public document:Document;

  constructor(public pFullName:String, public pDocument:Document) {
    this.fullName = pFullName;
    this.document = pDocument;
  }
}

class Document {
  public kind:String;
  public id:String;

  constructor(public pKind:String, public pId:String) {
    this.kind = pKind;
    this.id = pId;
  }
}
